'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Selectors = require('../constants/Selectors');

var _UIControlledPopover = require('./UIControlledPopover');

var _UIControlledPopover2 = _interopRequireDefault(_UIControlledPopover);

var _UITooltipContent = require('./UITooltipContent');

var _UITooltipContent2 = _interopRequireDefault(_UITooltipContent);

var _UITooltipHeader = require('./UITooltipHeader');

var _UITooltipHeader2 = _interopRequireDefault(_UITooltipHeader);

var _PlacementConstants = require('./PlacementConstants');

var _Hover = require('./utils/Hover');

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _Functions = require('../core/Functions');

var _focusStylesListener = require('../listeners/focusStylesListener');

var _Memoize = require('../core/Memoize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var USE_CLASSES = {
  default: 'tooltip-default private-tooltip--default',
  danger: 'tooltip-danger private-tooltip--danger',
  longform: 'private-tooltip--longform'
};

var instanceCount = 0;

var allTooltips = [];

var isDisabled = function isDisabled(props) {
  return props.disabled || props.Content == null && !props.title;
};
var isOpen = function isOpen(props) {
  return props.open && !isDisabled(props);
};

var getStyle = function getStyle(style, maxWidth) {
  return _extends({}, style, { maxWidth: maxWidth });
};

var getPopoverClassName = function getPopoverClassName(className, use) {
  return (0, _classNames2.default)(className, USE_CLASSES[use], 'tooltip', 'private-tooltip');
};

var getPopoverUse = function getPopoverUse(use) {
  if (use === 'default') return 'tooltip';
  if (use === 'danger') return 'tooltip-danger';
  return use;
};

var setOpen = function setOpen(component, newOpen) {
  if (!component._isMounted) return;
  if (newOpen && component.props.disabled) return;
  if (newOpen === component.props.open) return;
  component.props.onOpenChange((0, _SyntheticEvent2.default)(newOpen));
};

var getDelayedSetOpen = function getDelayedSetOpen(component, delay) {
  var boundSetOpen = function boundSetOpen() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return setOpen.apply(undefined, [component].concat(args));
  };
  return delay === 0 ? boundSetOpen : function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return setTimeout(function () {
      return boundSetOpen.apply(undefined, args);
    }, delay);
  };
};

var UITooltip = function (_PureComponent) {
  _inherits(UITooltip, _PureComponent);

  function UITooltip(props) {
    _classCallCheck(this, UITooltip);

    var _this = _possibleConstructorReturn(this, (UITooltip.__proto__ || Object.getPrototypeOf(UITooltip)).call(this, props));

    _this.state = {
      listeningForMouseMove: false
    };

    _this._hasOpened = false;

    instanceCount += 1;
    _this._tooltipId = 'uiTooltip-' + instanceCount;

    _this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    _this._setOpen = getDelayedSetOpen(_this, props.delay);
    _this.refCallback = _this.refCallback.bind(_this);
    _this.triggerClose = _this.triggerClose.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleBodyMouseMove = _this.handleBodyMouseMove.bind(_this);
    _this.handlePopoverFocusLeave = _this.handlePopoverFocusLeave.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  _createClass(UITooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      allTooltips.push(this);
      this._isMounted = true;
      if (isOpen(this.props)) {
        this.addBodyMouseListeners();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.delay !== this.props.delay) {
        this._setOpen = getDelayedSetOpen(this, nextProps.delay);
      }
      if (!isOpen(nextProps) && isOpen(this.props)) {
        this.setState({
          listeningForMouseMove: false
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (!isOpen(prevProps) && isOpen(this.props)) {
        this.addBodyMouseListeners();
        allTooltips.forEach(function (tooltip) {
          if (tooltip === _this2) return;
          if (tooltip._isMounted) {
            setOpen(tooltip, false);
          }
        });
      } else if (isOpen(prevProps) && !isOpen(this.props)) {
        this.removeBodyMouseListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      allTooltips.splice(allTooltips.indexOf(this), 1);
      this._isMounted = false;
      this.removeBodyMouseListeners();
    }
  }, {
    key: 'refCallback',
    value: function refCallback(ref) {
      this._ref = ref;
    }
  }, {
    key: 'addBodyMouseListeners',
    value: function addBodyMouseListeners() {
      if (!document.body) return;
      document.body.addEventListener('mouseleave', this.triggerClose);
      document.body.addEventListener('mousemove', this.handleBodyMouseMove);
    }
  }, {
    key: 'removeBodyMouseListeners',
    value: function removeBodyMouseListeners() {
      if (!document.body) return;
      document.body.removeEventListener('mouseleave', this.triggerClose);
      document.body.removeEventListener('mousemove', this.handleBodyMouseMove);
    }
  }, {
    key: 'triggerClose',
    value: function triggerClose() {
      var onClose = this.props.onClose;

      setOpen(this, false);
      this._closeOnPopoverFocusLeave = false;
      (0, _Functions.callIfPossible)(onClose);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      // Very special-case, but important for a11y: When we tab out of the tooltip
      // target, the focus moves to the first tabbable element inside of the
      // tooltip (if any). When that happens, we need to prevent the tooltip from
      // closing when the target blur event fires and instead close it when the
      // focus leaves the tooltip content.
      var key = evt.key,
          shiftKey = evt.shiftKey;

      if (key === 'Tab' && !shiftKey) {
        var tooltipEl = document.getElementById(this._tooltipId);
        if (!tooltipEl) {
          return;
        }
        if (tooltipEl.querySelector(_Selectors.FOCUSABLE)) {
          this._closeOnPopoverFocusLeave = true;
        }
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      if (this._closeOnPopoverFocusLeave || !this._wasOpenedByFocus) {
        return;
      }
      var targetEl = (0, _reactDom.findDOMNode)(this._ref);
      if (targetEl && targetEl.contains(document.activeElement)) {
        // If blur has occurred but document.activeElement still points to the
        // anchor element, it means the entire document has lost focus. See
        // HubSpot/UIComponents#784
        return;
      }
      this.triggerClose();
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      if (!(0, _focusStylesListener.isPageInKeyboardMode)()) return;
      this._wasOpenedByFocus = true;
      setOpen(this, true);
    }
  }, {
    key: 'handlePopoverFocusLeave',
    value: function handlePopoverFocusLeave() {
      if (this._closeOnPopoverFocusLeave) {
        this.triggerClose();
      }
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      var _this3 = this;

      // Workaround for React bug that allows handleMouseEnter to be called twice
      // for the same event (rare but possible!)
      if (this._holdTimeout) {
        return;
      }

      var delayOnHold = this.props.delayOnHold;

      this._openTimeout = this._setOpen(true);
      this._closeOnPopoverFocusLeave = false;
      this._holdTimeout = setTimeout(function () {
        setOpen(_this3, true);
      }, delayOnHold);
      this._wasOpenedByFocus = false;
      this.setState({
        listeningForMouseMove: true
      });
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      // If open has been triggered but a delay is in effect, cancel open.
      clearTimeout(this._openTimeout);
      this._openTimeout = null;
      clearTimeout(this._holdTimeout);
      this._holdTimeout = null;

      // If we're open, we need to keep listening to mousemove until the mouse has left the bounds of
      // the tooltip itself. Otherwise, we don't need the listener.
      this.setState({
        listeningForMouseMove: isOpen(this.props)
      });
    }
  }, {
    key: 'handleBodyMouseMove',
    value: function handleBodyMouseMove(evt) {
      var _this4 = this;

      if (!this._isMounted) return;

      var _props = this.props,
          delayOnHold = _props.delayOnHold,
          open = _props.open;

      if (open) {
        // Bail early and often if the target and/or tooltip aren't in the DOM
        var targetEl = (0, _reactDom.findDOMNode)(this._ref);
        if (!targetEl) return;
        var tooltipEl = document.getElementById(this._tooltipId);
        if (!tooltipEl) return;

        var tooltipArea = tooltipEl.getBoundingClientRect();
        var targetArea = targetEl.getBoundingClientRect();

        if ((0, _Hover.shouldTooltipClose)(targetArea, tooltipArea, evt)) {
          this.triggerClose();
        }
      } else if (this._holdTimeout) {
        clearTimeout(this._holdTimeout);
        this._holdTimeout = setTimeout(function () {
          setOpen(_this4, true);
        }, delayOnHold);
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props2 = this.props,
          innerClassName = _props2.innerClassName,
          headingText = _props2.headingText,
          title = _props2.title,
          use = _props2.use;

      return _react2.default.createElement(
        _UITooltipContent2.default,
        {
          className: (0, _classNames2.default)(innerClassName, 'tooltip-inner', {
            'has--vertical-spacing': use === 'longform'
          })
        },
        headingText != null ? _react2.default.createElement(
          _UITooltipHeader2.default,
          {
            className: (0, _classNames2.default)({
              'private-tooltip--longform__heading': use === 'longform'
            })
          },
          headingText
        ) : null,
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          className = _props3.className,
          Content = _props3.Content,
          __delay = _props3.delay,
          __delayOnHold = _props3.delayOnHold,
          __disabled = _props3.disabled,
          __headingText = _props3.headingText,
          __innerClassName = _props3.innerClassName,
          maxWidth = _props3.maxWidth,
          __onClose = _props3.onClose,
          __open = _props3.open,
          style = _props3.style,
          __title = _props3.title,
          use = _props3.use,
          rest = _objectWithoutProperties(_props3, ['children', 'className', 'Content', 'delay', 'delayOnHold', 'disabled', 'headingText', 'innerClassName', 'maxWidth', 'onClose', 'open', 'style', 'title', 'use']);

      var computedDisabled = isDisabled(this.props);
      var computedOpen = isOpen(this.props);

      var child = _react.Children.only(children);
      var clonedChild = void 0;
      if (!computedDisabled) {
        var computedDescribedBy = computedOpen ? ((child.props['aria-describedby'] || '') + ' ' + this._tooltipId).trim() : child.props['aria-describedby'];
        clonedChild = (0, _react.cloneElement)(child, {
          'aria-describedby': computedDescribedBy,
          onBlur: (0, _Functions.memoizedSequence)(this.handleBlur, child.props.onBlur),
          onFocus: (0, _Functions.memoizedSequence)(this.handleFocus, child.props.onFocus),
          onKeyDown: (0, _Functions.memoizedSequence)(this.handleKeyDown, child.props.onKeyDown),
          onMouseEnter: (0, _Functions.memoizedSequence)(this.handleMouseEnter, child.props.onMouseEnter),
          onMouseLeave: (0, _Functions.memoizedSequence)(this.handleMouseLeave, child.props.onMouseLeave),
          tabIndex: 0 // #4949
        });
      }

      // Perf: Don't generate props for popover if we've never been opened. (They props may still be
      // needed while computedOpen is false if the popover is transitioning.)
      this._hasOpened = this._hasOpened || computedOpen;
      var popoverProps = this._hasOpened ? _extends({}, rest, {
        arrowSize: use === 'longform' ? 'medium' : 'small',
        className: getPopoverClassName(className, use),
        closeOnTargetLeave: true,
        Content: Content || this.renderContent,
        id: this._tooltipId,
        onFocusLeave: this.handlePopoverFocusLeave,
        open: computedOpen,
        ref: this.refCallback,
        style: this._getStyle(style, maxWidth),
        use: getPopoverUse(use)
      }) : null;
      return _react2.default.createElement(
        _UIControlledPopover2.default,
        popoverProps,
        clonedChild || child
      );
    }
  }]);

  return UITooltip;
}(_react.PureComponent);

UITooltip.propTypes = {
  autoPlacement: _UIControlledPopover2.default.propTypes.autoPlacement,
  children: _react.PropTypes.node,
  Content: _UIControlledPopover2.default.propTypes.Content,
  delay: _react.PropTypes.number.isRequired,
  delayOnHold: _react.PropTypes.number.isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  headingText: _react.PropTypes.node,
  innerClassName: _react.PropTypes.string,
  maxWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  onClose: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func.isRequired,
  open: _react.PropTypes.bool.isRequired,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  title: _react.PropTypes.node,
  use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
  _bodyElement: _domElement2.default
};

UITooltip.defaultProps = {
  autoPlacement: true,
  delay: 300,
  delayOnHold: 100,
  disabled: false,
  open: false,
  placement: 'top',
  use: 'default'
};

UITooltip.displayName = 'UITooltip';

exports.default = (0, _Controllable2.default)(UITooltip, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tooltip/UITooltip.js
// module id = 47
// module chunks = 3 4 5